/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_LabelInputs */

const en_about_label = /** @type {(inputs: About_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Lindevo`)
};

const lv_about_label = /** @type {(inputs: About_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par Lindevo`)
};

/**
* | output |
* | --- |
* | "About Lindevo" |
*
* @param {About_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_label = /** @type {((inputs?: About_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_label(inputs)
	return en_about_label(inputs)
});